import List from '@material-ui/core/List'
import React from 'react'

import { Maybe, Menu as MenuProps } from '../../operations.wp/types'
import MenuItem from './MenuItem'

const IconsMenu = ({ menu }: { menu: Maybe<MenuProps> }) => {
  if (!menu?.menuItems?.nodes?.length) return null
  return (
    <List disablePadding component="div">
      {menu.menuItems.nodes.map(node => {
        if (!node) return null
        return <MenuItem key={node.id} fullWidth item={node} />
      })}
    </List>
  )
}

export default IconsMenu
